export * from './context-edit.component';
export * from './context-edit-binding.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/context/context-edit/index.ts